export const newsletterSignUpModal = (
    state = { },
    action
) => {
    switch (action.type) {
        default:
            return state;
    }
};